import { render, staticRenderFns } from "./PhoneDisplay.vue?vue&type=template&id=2b137537&scoped=true"
import script from "./PhoneDisplay.vue?vue&type=script&lang=js"
export * from "./PhoneDisplay.vue?vue&type=script&lang=js"
import style0 from "./PhoneDisplay.vue?vue&type=style&index=0&id=2b137537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b137537",
  null
  
)

export default component.exports